import { ReactComponent as Search } from 'assets/icons/search.svg';
import { ReactComponent as X } from 'assets/icons/X.svg';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSearch, selectSearchData } from 'store/slices/SearchSlice';

const clearText = 'Clear';
const placeholder = 'Search keywords by products, by resources';

const SearchComponent = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');

    const handleChange = e => setSearch(e.target.value);
    const handleClear = () => setSearch('');

    const { data } = useSelector(selectSearchData);

    console.log(data);

    useEffect(() => {
        // dispatch(fetchSearch());
    }, [dispatch, search]);

    return (
        <label className="search-control">
            <Search />
            <input
                value={search}
                onChange={handleChange}
                type="text"
                placeholder={placeholder}
                className="body1 search-control__input"
            />
            {!!search && (
                <button className="search-control__clear" onClick={handleClear}>
                    <span>{clearText}</span>
                    <X />
                </button>
            )}
        </label>
    );
};

export default SearchComponent;
